import constants from '@/constants';

export default {
  methods: {
    getActualStartTime(timePair) {
      if ('segmentTimePairs' in timePair) {
        const overtime = timePair.segmentTimePairs.find(
          (it) => (it.pairType === constants.WorkSchedule.SegmentType.EARLY_LOGIN
          || it.pairType === constants.WorkSchedule.SegmentType.PRE_SHIFT_OT)
          && it.deletedDate === null,
        );
        if (overtime && overtime.clockIn.date < timePair.clockIn.date) {
          return overtime.clockIn;
        }
      }
      return timePair.clockIn;
    },

    getActualEndTime(timePair) {
      if ('segmentTimePairs' in timePair) {
        const overtime = timePair.segmentTimePairs.slice().reverse().find((it) => (it.pairType === 'OVERTIME'
          || it.pairType === 'FIXED_OVERTIME') && it.deletedDate === null);
        if (overtime && overtime.clockOut.date > timePair.clockOut.date) {
          return overtime.clockOut;
        }
      }
      return timePair.clockOut;
    },
  },
};
